/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Menu_TitleInputs */

const en_dev_menu_title = /** @type {(inputs: Dev_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer Menu`)
};

const ar_dev_menu_title = /** @type {(inputs: Dev_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قائمة المطوّر`)
};

const bn_dev_menu_title = /** @type {(inputs: Dev_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেভেলপার মেনু`)
};

const de_dev_menu_title = /** @type {(inputs: Dev_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwicklermenü`)
};

const es_dev_menu_title = /** @type {(inputs: Dev_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú de desarrollador`)
};

const fr_dev_menu_title = /** @type {(inputs: Dev_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu développeur`)
};

const pt_dev_menu_title = /** @type {(inputs: Dev_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu do desenvolvedor`)
};

const zh_dev_menu_title = /** @type {(inputs: Dev_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开发者菜单`)
};

const tr_dev_menu_title = /** @type {(inputs: Dev_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliştirici Menüsü`)
};

const ru_dev_menu_title = /** @type {(inputs: Dev_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меню разработчика`)
};

const pl_dev_menu_title = /** @type {(inputs: Dev_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu programisty`)
};

/**
* | output |
* | --- |
* | "Developer Menu" |
*
* @param {Dev_Menu_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dev_menu_title = /** @type {((inputs?: Dev_Menu_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Menu_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dev_menu_title(inputs)
	if (locale === "bn") return bn_dev_menu_title(inputs)
	if (locale === "de") return de_dev_menu_title(inputs)
	if (locale === "es") return es_dev_menu_title(inputs)
	if (locale === "fr") return fr_dev_menu_title(inputs)
	if (locale === "pt") return pt_dev_menu_title(inputs)
	if (locale === "zh") return zh_dev_menu_title(inputs)
	if (locale === "tr") return tr_dev_menu_title(inputs)
	if (locale === "ru") return ru_dev_menu_title(inputs)
	if (locale === "pl") return pl_dev_menu_title(inputs)
	return en_dev_menu_title(inputs)
});